export default __webpack_public_path__ + "static/media/tile-2-short.c2dcb00d.png";